export const BRAND = "ספורט והעשרה";
export const YEAR = "שנה\"ל תשפ\"ז 26-27";

const IMG = {
  soccer:
    "https://images.unsplash.com/photo-1609422644211-a85c36ee36a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  basketball:
    "https://images.unsplash.com/photo-1559838831-d8fbd8af6469?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  judo:
    "https://images.unsplash.com/photo-1564415315949-7a0c4c73aab4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  chess:
    "https://images.pexels.com/photos/5691844/pexels-photo-5691844.jpeg?auto=compress&cs=tinysrgb&w=1400",
  hiphop:
    "https://images.unsplash.com/photo-1609602886239-a55db9685b7c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  dogs:
    "https://images.pexels.com/photos/7210456/pexels-photo-7210456.jpeg?auto=compress&cs=tinysrgb&w=1400",
  robotics:
    "https://images.unsplash.com/photo-1585980243496-fe29a36bd382?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Shared descriptive metadata per club (same across schools)
const meta = {
  kaduregel: {
    name: "כדורגל",
    field: "ספורט וכושר",
    tagline: "טכניקה, כושר ורוח קבוצתית על הדשא",
    color: "#16a34a",
    image: IMG.soccer,
    short: "לימוד יסודות המשחק, עבודת צוות, טכניקה ובניית כושר משחקי בסביבה תומכת ומהנה.",
    long: "בחוג הכדורגל הילדים לומדים את יסודות המשחק בצורה הדרגתית ומקצועית: מסירות, בעיטות, שליטה בכדור ומשחק קבוצתי. הדגש הוא על הנאה, כושר גופני, משמעת עצמית ורוח ספורטיבית. כל אימון בנוי כך שכל ילד מקבל זמן משחק, מרגיש חלק מהקבוצה ומתקדם בקצב שלו.",
  },
  kadursal: {
    name: "כדורסל",
    field: "ספורט וכושר",
    tagline: "כדרור, קליעה ומשחק חכם",
    color: "#ea580c",
    image: IMG.basketball,
    short: "שיפור השליטה בכדור, קליעה, מסירות ותנועה במגרש, עם דגש על עבודת צוות וספורטיביות.",
    long: "חוג הכדורסל מפתח שליטה בכדור, דיוק בקליעה, מסירות ותנועה נכונה במגרש. מעבר למיומנויות, הילדים לומדים לקבל החלטות מהירות, לשתף פעולה ולשחק כקבוצה. האווירה מקצועית אך כיפית, ומותאמת לכל רמה.",
  },
  judo: {
    name: "ג'ודו",
    field: "ספורט וכושר",
    tagline: "משמעת, כבוד וביטחון עצמי",
    color: "#dc2626",
    image: IMG.judo,
    short: "לימוד יסודות הג'ודו, משמעת עצמית, כבוד והגנה עצמית באווירה תומכת ומקצועית.",
    long: "בחוג הג'ודו הילדים רוכשים את יסודות אמנות הלחימה היפנית לצד ערכים של כבוד, משמעת עצמית וריכוז. האימונים מחזקים את הגוף, משפרים קואורדינציה ושיווי משקל, ומקנים ביטחון עצמי וכלים להגנה עצמית בסביבה בטוחה ומפוקחת.",
  },
  chess: {
    name: "שחמט",
    field: "ספורט וכושר",
    tagline: "שחמט עם נשמה — הרבה יותר ממשחק",
    color: "#4f46e5",
    featured: true,
    image: IMG.chess,
    short: "לא רק מהלך נכון על הלוח — בניית ביטחון עצמי, סבלנות, חשיבה עצמאית ויכולת קבלת החלטות.",
    long: "\"שחמט עם נשמה\" הוא מסגרת לימוד שמחברת בין מקצועיות בשחמט לבין קשר אנושי אמיתי עם התלמידים. כל תלמיד מקבל יחס אישי, זמן ושקט כדי לבנות חוסן רגשי, לחשוב באופן עצמאי ולהתפתח בקצב שמתאים לו. המטרה: ביטחון עצמי, אחריות, סבלנות ויכולת קבלת החלטות — ככלים לחיים.",
  },
  hiphop: {
    name: "היפ הופ",
    field: "אומנויות ובמה",
    tagline: "קצב, תנועה וסטייל אישי על הבמה",
    color: "#db2777",
    image: IMG.hiphop,
    short: "חוג קצב ותנועה המשלב צעדים עדכניים, פיתוח סטייל אישי ותחושת במה וביטחון.",
    long: "חוג ההיפ הופ משלב צעדים עדכניים, קואורדינציה, קצב ותחושת במה. הילדים מפתחים סטייל אישי, ביטחון עצמי ויכולת ביטוי דרך התנועה. השיעורים אנרגטיים, כיפיים ומסתיימים בכוריאוגרפיות מגובשות שמעצימות את הביטחון של כל ילד.",
  },
  dogs: {
    name: "אילוף כלבים",
    field: "חיות וטכנולוגיה",
    tagline: "תקשורת, אחריות וקשר אמיתי עם בעלי חיים",
    color: "#ca8a04",
    image: IMG.dogs,
    short: "חוג חווייתי ללימוד תקשורת נכונה עם כלבים, פקודות בסיסיות וטיפוח קשר בין הילד לכלב.",
    long: "חוג חווייתי וייחודי שבו הילדים לומדים לתקשר נכון עם כלבים, להעביר פקודות בסיסיות ולהבין את שפת הגוף של בעלי החיים. לצד ההנאה, החוג מפתח אחריות, אמפתיה, סבלנות וביטחון עצמי דרך קשר אמיתי ומרגש עם הכלבים.",
  },
  robotics: {
    name: "רובוטיקה פלוס",
    field: "חיות וטכנולוגיה",
    tagline: "רובוטיקה, אלקטרוניקה ובינה מלאכותית — עם STEM School",
    color: "#0891b2",
    image: "/robotics.jpg",
    short: "בשיתוף STEM School — רובוטיקה, אלקטרוניקה ובינה מלאכותית להייטקיסטים הצעירים, עם פרויקטים שהילדים לוקחים הביתה.",
    long: "חוג הרובוטיקה בשיתוף STEM School משלב רובוטיקה, אלקטרוניקה ובינה מלאכותית להייטקיסטים הצעירים. מאחורי החוג עומד ניסיון של 15 שנה בתחום, עם שלל פרויקטים מרתקים שהילדים בונים ולוקחים איתם הביתה. החוגים והקייטנות של STEM School אהובים על תושבי צור הדסה, ומעניקים לילדים חשיפה חווייתית לעולם הטכנולוגי של המחר.",
  },
};

const build = (id, extra) => ({ id, ...meta[id], ...extra });

// ---- מעיינות ----
const maayanotClubs = [
  build("kaduregel", {
    instructor: "אופיר עמרם וצוות מאמנים מוסמך",
    price: 210,
    schedule: [
      { grades: "א'-ג'", day: "רביעי", time: "14:30-15:30", price: 210 },
      { grades: "ד'-ו'", day: "רביעי", time: "13:30-14:30", price: 210 },
    ],
  }),
  build("kadursal", {
    instructor: "מתנאל נחמיאס, מעיין טנא וצוות",
    price: 210,
    schedule: [
      { grades: "א'-ג'", day: "שלישי", time: "13:30-14:30", price: 210 },
      { grades: "ד'-ו'", day: "שלישי", time: "14:30-15:30", price: 210 },
    ],
  }),
  build("judo", {
    instructor: "אבי לנדסברג",
    instructorPhone: "054-5587738",
    poster: "/judo-maayanot-poster.jpg",
    price: 210,
    schedule: [{ grades: "א'-ו'", day: "רביעי", time: "14:45-15:30", price: 210 }],
  }),
  build("hiphop", {
    instructor: "מלי אדלמן",
    instructorImage: "/mali-adelman.jpg",
    instructorPhone: "054-4644169",
    price: 230,
    schedule: [
      { grades: "ד'-ו'", day: "שלישי", time: "13:40-14:30", price: 230 },
      { grades: "א'-ג'", day: "שלישי", time: "14:30-15:20", price: 230 },
    ],
  }),
  build("dogs", {
    instructor: "דן אולארצ'יק",
    instructorPhone: "054-2243293",
    whatsappGroup: "https://chat.whatsapp.com/DmRmKzv6WVXGoTDnNMJMz7",
    price: 260,
    schedule: [
      { grades: "א'-ג'", day: "חמישי", time: "14:30-15:30", price: 260 },
      { grades: "ד'-ו'", day: "חמישי", time: "13:30-14:30", price: 260 },
    ],
  }),
  build("robotics", {
    instructor: "ד\"ר אלן סליס — STEM School",
    instructorPhone: "053-5964626",
    price: 285,
    schedule: [{ grades: "רב גילאי", day: "שני", time: "13:30-14:30", price: 285 }],
  }),
];

// ---- הדסים · צורים ----
const hadassimClubs = [
  build("kaduregel", {
    instructor: "אופיר עמרם וצוות מאמנים מוסמך",
    price: 210,
    schedule: [
      { grades: "ד'-ו'", day: "חמישי", time: "13:30-14:30", price: 210 },
      { grades: "א'-ג'", day: "חמישי", time: "14:30-15:30", price: 210 },
    ],
  }),
  build("kadursal", {
    instructor: "צוות מאמנים מוסמך",
    price: 210,
    schedule: [
      { grades: "א'-ג'", day: "ראשון", time: "13:30-14:30", price: 210 },
      { grades: "ד'-ו' + כדורסל בנות", day: "ראשון", time: "14:30-15:30", price: 210 },
    ],
  }),
  build("judo", {
    instructor: "אבי לנדסברג",
    instructorPhone: "054-5587738",
    price: 210,
    scheduleNote: "פרטים בהמשך",
    schedule: [],
  }),
  build("hiphop", {
    name: "מחול",
    image: "/machol-hadassim.jpg",
    tagline: "תנועה, קצב וביטוי אישי על הבמה",
    short: "חוג מחול המשלב טכניקה, קצב ותנועה — לפיתוח ביטוי אישי, ביטחון ותחושת במה.",
    long: "חוג המחול משלב טכניקה, קצב ותנועה, ומאפשר לכל ילד/ה לפתח ביטוי אישי, קואורדינציה, גמישות וביטחון עצמי. השיעורים חווייתיים ומהנים, ומסתיימים במופעים וכוריאוגרפיות שמעצימים את תחושת ההצלחה והבמה.",
    instructor: "טל שאבי כנען",
    price: 230,
    schedule: [
      { grades: "ד'-ו'", day: "שלישי", time: "12:50-13:50", price: 230 },
      { grades: "א'-ג'", day: "רביעי", time: "13:40-14:30", price: 230 },
    ],
  }),
  build("dogs", {
    instructor: "דן אולארצ'יק",
    instructorPhone: "054-2243293",
    price: 260,
    scheduleNote: "יפתח בהמשך בהתאם להרשמה",
    schedule: [],
  }),
  build("robotics", {
    instructor: "ד\"ר אלן סליס — STEM School",
    instructorPhone: "053-5964626",
    price: 285,
    schedule: [{ grades: "רב גילאי", day: "שלישי", time: "13:00-14:00", price: 285 }],
  }),
];

export const schools = {
  maayanot: {
    id: "maayanot",
    name: "מעיינות",
    label: "בית ספר מעיינות",
    clubs: maayanotClubs,
    regUrl:
      "https://xbm36fyi.web.arboxapp.com/course?whitelabel=Arbox&lang=he&location=23894&referrer=SITE&allLocations=false",
  },
  hadassim: {
    id: "hadassim",
    name: "הדסים · צורים",
    label: "הדסים · צורים",
    clubs: hadassimClubs,
    regUrl:
      "https://xbm36fyi.web.arboxapp.com/course?whitelabel=Arbox&lang=he&location=24002&referrer=SITE&allLocations=false",
  },
};

export const weekLessons = {
  maayanot: [
    {
      day: "שני 5/10",
      items: [{ club: "רובוטיקה", time: "13:30", note: "לכולם!" }],
    },
    {
      day: "שלישי 6/10",
      items: [
        { club: "כדורסל", time: "13:30", note: "לכולם!" },
        { club: "היפ הופ", time: "13:40-14:30", note: "הקבוצה השנייה תיפתח בהמשך בהתאם להרשמה!" },
      ],
    },
    {
      day: "רביעי 7/10",
      items: [
        { club: "כדורגל ד'-ו'", time: "13:30" },
        { club: "כדורגל א'-ג'", time: "14:30" },
        { club: "ג'ודו", time: "14:45" },
      ],
    },
    {
      day: "חמישי",
      items: [{ club: "אילוף כלבים", note: "הרשמה מראש אצל דן!" }],
    },
  ],
  hadassim: [
    {
      day: "שלישי 6/10",
      items: [
        { club: "מחול ד'-ו'", time: "12:50" },
        { club: "רובוטיקה", time: "13:00" },
      ],
    },
    {
      day: "רביעי 7/10",
      items: [{ club: "מחול", time: "13:40" }],
    },
  ],
};

export const schoolList = [
  { id: "maayanot", name: "מעיינות" },
  { id: "hadassim", name: "הדסים · צורים" },
];

export const SCHOOLS = ["מעיינות", "הדסים", "צורים"];

export function getSchool(id) {
  return schools[id] || schools.maayanot;
}
export function getClub(schoolId, clubId) {
  return getSchool(schoolId).clubs.find((c) => c.id === clubId);
}

// Back-compat default export list (מעיינות)
export const clubs = maayanotClubs;

export const chessManifesto = {
  title: "שחמט עם נשמה",
  author: "יצחק דוצ'ין",
  role: "מורה מוסמך מטעם האיגוד הישראלי לשחמט, מדריך שחמט וארביטר (שופט)",
  chapters: [
    {
      n: "01",
      heading: "הרבה יותר ממשחק",
      text: "השחמט בשבילי הוא הרבה יותר ממשחק. לאורך החיים שלי הוא היה מקום של שקט, ריכוז, משמעות והתפתחות אישית. דרכו למדתי להתמודד עם הפסדים, לקבל החלטות תחת לחץ, לחשוב קדימה ולהאמין ביכולת להשתפר. אלו לא רק מיומנויות של לוח — אלו כלים לחיים.",
    },
    {
      n: "02",
      heading: "מקצועיות עם קשר אנושי",
      text: "מתוך החוויה האישית הזאת הקמתי את \"שחמט עם נשמה\" — מסגרת לימוד שמחברת בין מקצועיות בשחמט לבין קשר אנושי אמיתי עם התלמידים. אני מלמד ילדים ונוער מתוך אהבה גדולה למשחק ומתוך אמונה עמוקה בכוח החינוכי שלו.",
    },
    {
      n: "03",
      heading: "מקום לחשיבה וגם לרגש",
      text: "אני מאמין שילד לומד באמת רק כשהוא מרגיש בטוח, מובן ומוערך. לכן בשיעורים שלי יש מקום גם לחשיבה וגם לרגש. כל תלמיד מקבל יחס אישי, זמן, שקט וביטחון כדי לבנות חוסן רגשי, לחשוב באופן עצמאי ולהתפתח בקצב שמתאים לו.",
    },
    {
      n: "04",
      heading: "בסיס להצלחה בחיים",
      text: "המטרה היא לא רק ללמד מהלך נכון על הלוח, אלא לעזור לילד לבנות ביטחון עצמי, אחריות, סבלנות ויכולת קבלת החלטות — כבסיס להצלחה בחיים. השיעורים מותאמים לכל תלמיד באופן אישי, עם הקשבה מלאה לצרכים של הילדים וההורים כאחד.",
    },
  ],
};

export const contacts = [
  { name: "מעיין טנא", phone: "050-7210131" },
  { name: "אופיר עמרם", phone: "050-2288424" },
];
